import "./src/styles/tailwind.css";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import "./src/styles/vanilla-cookieconsent-overrides.css";
import { cookieConsentConfig } from "./src/config/vanilla-cookieconsent.config";
import type { GatsbyBrowser } from "gatsby";

declare global {
    interface Window {
        dataLayer?: any[];
        gtag?: (...args: any[]) => void;
    }
}

export const onClientEntry: GatsbyBrowser["onClientEntry"] = async () => {
    if (typeof window === "undefined") {
        return;
    }

    const CookieConsent = await import("vanilla-cookieconsent");

    CookieConsent.run(cookieConsentConfig);

    window.addEventListener("cc:onConsent", () => {
        if (CookieConsent.acceptedCategory("analytics")) {
            loadGoogleAnalytics();
        }
    });

    window.addEventListener("cc:onChange", () => {
        if (CookieConsent.acceptedCategory("analytics")) {
            loadGoogleAnalytics();
        } else {
            removeGoogleAnalytics();
        }
    });
};

let isGALoaded = false;
let isGALoading = false;

const loadGoogleAnalytics = (): void => {
    const GA_MEASUREMENT_ID = "G-32DFBPESMJ";

    // Avoid loading GA multiple times
    if (isGALoaded || isGALoading) {
        return;
    }

    if (document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`)) {
        isGALoaded = true;
        return;
    }

    isGALoading = true;

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;

    script.onload = () => {
        isGALoaded = true;
        isGALoading = false;
    };

    script.onerror = () => {
        isGALoading = false;
    };

    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function (...args: any[]): void {
        window.dataLayer!.push(arguments);
    };

    window.gtag("js", new Date());
    window.gtag("config", GA_MEASUREMENT_ID, {
        anonymize_ip: true,
        cookie_flags: "SameSite=None;Secure",
    });
};

const removeGoogleAnalytics = (): void => {
    const cookies = ["_ga", "_gat", "_gid"];
    cookies.forEach((cookie) => {
        document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });

    const scripts = document.querySelectorAll('script[src*="googletagmanager.com"]');
    scripts.forEach((script) => script.remove());
};

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = async () => {
    if (typeof window === "undefined") {
        return;
    }

    const CookieConsent = await import("vanilla-cookieconsent");

    if (window.gtag && CookieConsent.acceptedCategory("analytics")) {
        window.gtag("config", "G-32DFBPESMJ", {
            page_path: window.location.pathname,
        });
    }
};
